import styled from 'styled-components';

import { Button as DefaultButton } from '@xing-com/button';
import { mediaSmallOrTiny } from '@xing-com/layout-tokens';
import { Dropdown as DefaultDropdown } from '@xing-com/text-field';
import { spaceL, spaceM, spaceXL, spaceXXL } from '@xing-com/tokens';
import {
  BodyCopy,
  BodyCopy as DefaultBodyCopy,
  Headline as DefaultHeadline,
} from '@xing-com/typography';
export const LegalText = styled(DefaultBodyCopy)`
  margin-top: ${spaceXL};
`;

export const SaveAndContinueButton = styled(DefaultButton)`
  @media ${mediaSmallOrTiny} {
    width: 100%;
  }
`;

export const Content = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;

  @media ${mediaSmallOrTiny} {
    padding: ${spaceXL};
  }
`;

export const SubHeadline = styled(BodyCopy)`
  margin-bottom: ${spaceXXL};
`;

export const QuestionsContainer = styled.div`
  display: grid;
  gap: ${spaceXL};
`;

export const QuestionFieldset = styled.fieldset`
  border: 0;
  margin: 0;
  padding: 0;
`;

export const QuestionLegend = styled.legend`
  margin-bottom: ${spaceL};
  font-weight: bold;
`;

export const OptionLabel = styled.label`
  display: flex;
  align-items: center;
  gap: ${spaceM};
`;

export const LanguageLevelDropdown = styled(DefaultDropdown)`
  width: 100%;
`;

export const Actions = styled.div`
  display: flex;
  gap: ${spaceM};
  justify-content: flex-end;
  margin-top: auto;
  padding-top: ${spaceXXL};
`;

export const Headline = styled(DefaultHeadline)`
  margin-bottom: 0;
`;
